@if (modalService.config(); as config) {
  <app-modal
    [visible]="true"
    [type]="config.type ?? 'none'"
    [title]="config.title"
    [message]="config.message ?? ''"
    [confirmText]="config.confirmText ?? 'Aceptar'"
    [cancelText]="config.cancelText ?? 'Cancelar'"
    [showCancel]="config.showCancel ?? false"
    [showCloseIcon]="config.showCloseIcon ?? false"
    [closeOnBackdrop]="config.closeOnBackdrop ?? true"
    [confirmDisabled]="config.confirmDisabled ?? false"
    (confirm)="modalService.confirm()"
    (cancel)="modalService.cancel()"
  />
}
